import React from 'react'
import { Spinner as ChakraSpinner } from '@chakra-ui/react'
import { SpinnerProps } from './types'
import { Sizes, Thicknesses } from './constants'

const Spinner = ({
  size = Sizes.ExtraLarge,
  hiddenLabel = 'Loading...',
  ...restProps
}: SpinnerProps) => (
  <ChakraSpinner
    thickness={Thicknesses[size]}
    speed="1s"
    emptyColor="gray.200"
    color="blue.500"
    size={size}
    label={hiddenLabel} // this is for accessibility purposes, not a visible label
    {...restProps}
  />
)

export default Spinner
